import { Component, Input, OnInit } from '@angular/core';
import { CalibrationRequestToStatusService } from 'src/app/Service/Calibration/CalibrationRequestToStatus.service';

@Component({
  selector: 'app-CalibrationInPositionRequestStatus',
  templateUrl: './CalibrationInPositionRequestStatus.component.html',
  styleUrls: ['./CalibrationInPositionRequestStatus.component.scss']
})
export class CalibrationInPositionRequestStatusComponent implements OnInit {

  @Input() inner_calibration_id: number = 0
  
  customerName: String = ''
  code: String = ''
  code2: String = ''
  expert: String = ''
  deviceName: String = ''
  deviceCode: String = ''
  deviceSerial: String = ''
  dsc: String = ''

  constructor(
    private CalibrationRequestToStatus_Service: CalibrationRequestToStatusService,
  ) { }

  ngOnInit() {
    this.ReadData_Calibration_Request()
  }

  ReadData_Calibration_Request(){
    this.CalibrationRequestToStatus_Service.GetCalibrationStatus(this.inner_calibration_id).subscribe(
      data=>{
        this.customerName=data['customerName']
        this.code=data['code']
        this.code2=data['code2']
        this.expert=data['expert']
        this.dsc=data['dsc']

      }
    )
  }
}
